module.exports = __webpack_public_path__ + "img/emoPlaces.847d2199.svg";